const createLinearGradient = (
  context,
  {
    x1, y1, x2, y2, ...gradientColors
  },
) => {
  const ctx = context;
  const grd = ctx.createLinearGradient(x1, y1, x2, y2);

  Object.values(gradientColors).forEach((gradientColor, index) => {
    grd.addColorStop(index, gradientColor);
  });
  return grd;
};

export const createGradientColoredColumn = (columnMaxHeight, ...gradientColors) => (context) => {
  const { chart, parsed } = context;
  const { ctx, chartArea } = chart;
  if (!chartArea || !parsed) {
    // This case happens on initial chart load
    return null;
  }
  const chartHeight = chartArea.bottom - chartArea.top;
  return createLinearGradient(ctx, {
    x1: chartArea.left,
    y1: chartArea.bottom - chartHeight * parsed.y / (columnMaxHeight || 1),
    x2: chartArea.left,
    y2: chartArea.bottom,
    ...gradientColors,
  });
};

export const sortChartDataKeys = (keys) => keys.sort((key1, key2) => {
  const [year1, month1] = key1.split('_');
  const [year2, month2] = key2.split('_');

  if (Number(year1) > Number(year2)) return 1;

  if (Number(year1) === Number(year2) && Number(month1) > Number(month2)) return 1;

  return -1;
});
